import React, { useContext, useEffect, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';

// @mui/material components
import CircularProgress from '@mui/material/CircularProgress';

// Icons

// core components
import { LAYOUT_TYPES } from '../../constants/ThemeOptions';
import VerticalMinimal from './VerticalLayouts/VerticalMinimal/VerticalMinimal';

// Styles
import makeStyles from '@mui/styles/makeStyles';
import globalStyles from '../../../theme/GlobalCss';

// actions
import AppContext from '../contextProvider/AppContextProvider/AppContext';
import { homePage, IsLocalDevOrServerDev, localeStorageAccessTokenKey, localeStorageLanguageKey } from 'config/config';
import { useTranslation } from 'react-i18next';
import { loginWithCookie } from 'redux/Account/AccountAction';
import { getQueryStrings } from 'services/Utilities/Utilities';

// Others

const useStyles = makeStyles(() => ({
  circularProgressRoot: {
    position: 'absolute',
    left: 0,
    top: 0,
    zIndex: 1,
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));

const AppLayout = ({ children }) => {
  const [showLayoutLoader, setLayoutLoader] = useState(false);

  const { layout } = useContext(AppContext);
  const { i18n } = useTranslation();

  const history = useHistory();
  const dispatch = useDispatch();

  const classes = useStyles();
  const location = useLocation();
  globalStyles();

  const accountReducer = useSelector(state => state.AccountReducer);

  useEffect(() => {
    if (accountReducer.token && !accountReducer.isLoggedIn && !accountReducer.isLoggingIn && IsLocalDevOrServerDev) {
      setLayoutLoader(true);

      dispatch(loginWithCookie(accountReducer.token))
        .then(user => {
          var preferredLanguage = user.person?.preferredLanguage;

          if (preferredLanguage && i18n.language !== preferredLanguage) {
            localStorage.setItem(localeStorageLanguageKey, preferredLanguage);
            i18n.changeLanguage(preferredLanguage);
            if (preferredLanguage === 'fr') moment.locale('fr-CA');
            else moment.locale('en-CA');
          }

          setLayoutLoader(false);

          let queryStrings = getQueryStrings();
          let returnUrl = queryStrings['returnUrl'];
          history.push(`${returnUrl || homePage}`);
        })
        .catch(e => {
          setLayoutLoader(false);
          localStorage.removeItem(localeStorageAccessTokenKey);
          history.push('/dealer');
        });
    } else {
      setLayoutLoader(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accountReducer, dispatch, i18n]);

  if (showLayoutLoader || accountReducer.isLoggingIn) {
    return (
      <div className={classes.circularProgressRoot}>
        <CircularProgress />
      </div>
    );
  }

  if (
    ['/', '/signin', '/signup', '/forgot-password', '/activate-account', '/signed-in'].includes(location.pathname) ||
    location.pathname.startsWith('/reset-password')
  ) {
    return <div style={{ minHeight: '100vh', width: '100%', display: 'flex' }}>{children}</div>;
  }

  switch (layout) {
    case LAYOUT_TYPES.VERTICAL_MINIMAL: {
      return <VerticalMinimal children={children} />;
    }
    default:
      return <VerticalMinimal children={children} />;
  }
};

export default AppLayout;
